import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Link } from "@mui/material";
import ProductsCollectionItem from "./ProductsCollectionItem";

const PRODUCTS_BEFORE_FOLD = 6;

const ShopThisLook = ({ products, userId, contentId }) => {
    const [showAll, setShowAll] = useState(false);
    const items = products || [];

    if (items.length === 0) {
        return null;
    }

    const visible = showAll ? items : items.slice(0, PRODUCTS_BEFORE_FOLD);

    return (
        <>
            <Box
                sx={{
                    fontSize: "11px",
                    letterSpacing: "1.2px",
                    textTransform: "uppercase",
                    color: (theme) => theme.tvp.textSubtle,
                    marginBottom: "14px",
                }}
            >
                {`Shop this look — ${items.length} ${items.length === 1 ? "product" : "products"}`}
            </Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
                    gap: "18px",
                }}
            >
                {visible.map((product, index) => (
                    <ProductsCollectionItem
                        key={product.product_id || product.id}
                        index={index}
                        item={product}
                        linkOnly
                        userId={userId}
                        contentId={contentId}
                    />
                ))}
            </Box>
            {items.length > PRODUCTS_BEFORE_FOLD && (
                <Link
                    component="button"
                    type="button"
                    underline="none"
                    onClick={() => setShowAll((shown) => !shown)}
                    sx={{
                        display: "block",
                        marginTop: "16px",
                        fontSize: "13px",
                        color: (theme) => theme.tvp.textBody,
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    {showAll ? "Show less" : `View all ${items.length} products`}
                </Link>
            )}
        </>
    );
};

ShopThisLook.propTypes = {
    products: PropTypes.array,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    contentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ShopThisLook;
